import Types from "Types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetAdbRegroupement } from "../../../hooks/AdministrateurDeBien";
import {
  useGetFonctionsPostes,
  usePostUtilisateur,
} from "../../../hooks/Utilisateurs";
import { Selectors as AdbSelectors } from "../../../redux/AdministrateurDeBien";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import { Utilisateur } from "../../../services/Api/swagger";

export const useAjouterUtilisateur = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state),
  );
  const adbId = useSelector((state: Types.RootState) =>
    AdbSelectors.getAdbId(state),
  );
  const adbSelectedDetail = useSelector((state: Types.RootState) =>
    AdbSelectors.getSelectedAdbDetail(state),
  );

  const {
    data: fonctionsPostes,
    error: fonctionsPostesError,
    isFetching: fonctionsPostesFetching,
  } = useGetFonctionsPostes();
  const { mutate: mutateAdbRegroupement, data: adbRegroupementList } =
    useGetAdbRegroupement();

  const getADBRegroupementList = (params: number) => {
    mutateAdbRegroupement(params);
  };

  const selectedAdb = useSelector((state: Types.RootState) =>
    AdbSelectors.getADBDetail(state),
  );

  const {
    mutate: mutateAddUtilisateur,
    isLoading: utilisateurFetching,
    error: utilisateurError,
    reset: resetPostUtilisateur,
  } = usePostUtilisateur();
  const ajouterUtilisateur = (param: Utilisateur) => {
    mutateAddUtilisateur(param);
  };

  useEffect(() => {
    if (utilisateurConnecte?.role === "BESSE" && adbId) {
      getADBRegroupementList(adbId);
    }
  }, [utilisateurConnecte, adbId]);

  return {
    fonctionsPostes,
    getADBRegroupementList,
    adbRegroupementList,
    ajouterUtilisateur,
    selectedAdb,
    adbId,
    adbSelectedDetail,
    fonctionsPostesError,
    utilisateurConnecte,
    utilisateurFetching,
    utilisateurError,
    fonctionsPostesFetching,
    resetPostUtilisateur,
  };
};
